import axiosClient from "./axiosClient";


export const getMyStores = async () => {
    try {
        const response = await axiosClient.get('/stores');
        return response.data.data.stores;
    } catch (error) {
        throw error;
    }
};


export const getStoreInfo = async (uuid) => {
    try {
        const response = await axiosClient.get(`/stores/${uuid}`);
        return response.data.data;
    } catch (error) {
        throw error;
    }
};


export const getChannelsByStore = async (uuid) => {
    try {
        const response = await axiosClient.get(`/stores/${uuid}/channels`);
        return response.data.data.channels;
    } catch (error) {
        throw error;
    }
};


export const getChannel = async (storeUuid, channelUuid) => {
    try {
        const response = await axiosClient.get(`/stores/${storeUuid}/channels/${channelUuid}`);
        return response.data.data.channel;
    } catch (error) {
        throw error;
    }
};


export const getVirtualNumber = async (uuid) => {
    try {
        const response = await axiosClient.get(`/stores/${uuid}/virtual-number`);
        return response.data.data.virtual_number ?? null;
    } catch {
        return null;
    }
};


export const createStore = async (data) => {
    try {
        const response = await axiosClient.post('/stores', data);
        return response.data.data;
    } catch (error) {
        throw error;
    }
};


export const deleteStore = async (uuid) => {
    try {
        const response = await axiosClient.delete(`/stores/${uuid}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};


export const createChannel = async (storeUuid, data) => {
    try {
        const response = await axiosClient.post(`/stores/${storeUuid}/channels`, data);
        return response.data.data;
    } catch (error) {
        throw error;
    }
};


export const getStoreSettings = async (uuid) => {
    try {
        const response = await axiosClient.get(`/stores/${uuid}/settings`);
        return response.data.data;
    } catch (error) {
        throw error;
    }
};


export const createStoreSettings = async (uuid, data) => {
    try {
        const response = await axiosClient.post(`/stores/${uuid}/settings`, data);
        return response.data.data;
    } catch (error) {
        throw error;
    }
};


export const updateStoreSettings = async (uuid, data) => {
    try {
        const response = await axiosClient.put(`/stores/${uuid}/settings`, data);
        return response.data.data;
    } catch (error) {
        throw error;
    }
};
